import React from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'

import MoreLessButton from '../../atoms/MoreLessButton'

import './styles.scss'

const CartItem = ({ item, updateInCart, isGift }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const cart = useSelector(state => state.cart)

  const formatPrice = item => {
    const qty = isGift ? (item.quantity - 1) : item.quantity
    return Number((item.price * qty - item.total_discount) / 100).toFixed(2)
  }

  const quantity = product => product.quantity

  const add = item => dispatch(updateInCart(item, item.quantity + 1))

  const remove = item => dispatch(updateInCart(item, item.quantity - 1))

  const navigateToProduct = item => {
    if (item.discounted_price > 0) {
      const formatedBox = item.properties._bundle_box
      if (item.sku.includes('BUNDLE') && formatedBox) {
        formatedBox.bundle_id = item.variant_id
        formatedBox.upsells = []
        window.location.href = `${t('shared:iconicUrl')}/size?params=${JSON.stringify(formatedBox)}`
      } else {
        window.location.href = item.url
      }
    }
  }

  return (
    <div className='cart-item'>
      <img src={item.image} onClick={() => navigateToProduct(item)} />
      <div className='cart-item-infos'>
        <div className='cart-item-header'>
          <div className='cart-item-title' onClick={() => navigateToProduct(item)}>
            {item.product_title}
          </div>
          <div className='cart-item-price'>
            {formatPrice(item) > 0
              ? t('general:dynamicPrice', { price: formatPrice(item) })
              : t('general:free')}
          </div>
        </div>
        {item.sku.includes('BUNDLE')
          ? <div className='cart-item-description'>
            {Object.entries(item.properties).map(([key, value]) => {
              if (!key.includes('_')) {
                let rangeName = null
                if (key.charAt(0) === key.charAt(0).toUpperCase()) {
                  if (key.includes('Adèle')) {
                    rangeName = t('general:ranges:origin')
                  } else if (key.includes('One') || key.includes('Roland')) {
                    rangeName = t('general:ranges:one')
                    key = key.replace('Roland', '')
                  } else {
                    rangeName = t('general:ranges:iconic')
                  }
                }

                return (
                  <p key={key}>
                    <span><i>{rangeName}</i> <b>{key} : </b></span> {value}
                  </p>
                )
              }
            })}

          </div>
          : item.options_with_values?.find(option => option.name === 'Taille' || option.name === 'Imprimé')
            ? <div className='cart-item-description'>
              {item.options_with_values.map(({ name, value }) => <p key={name}><span>{name} :</span> {value}</p>)}
            </div>
            : item.variant_title && <div className='cart-item-description'>
              {item.variant_options.map(option => <p key={option}>{option}</p>)}
            </div>}
        <div className='more-less-container-wrapper'>
          <MoreLessButton
            quantity={quantity}
            add={add}
            remove={remove}
            item={item}
            subscription={cart}
            disableAddBtn={item.product_type === 'freebie'}
          />
          {item.sku.includes('BUNDLE') && item.properties._bundle_box &&
            <p onClick={() => navigateToProduct(item)}>
              <svg width='16' height='16' viewBox='0 0 12 12' fill='#199B8D' xmlns='http://www.w3.org/2000/svg'>
                <path d='M1.5 8.62503V10.5H3.375L8.905 4.97003L7.03 3.09503L1.5 8.62503ZM10.355 3.52003C10.55 3.32503 10.55 3.01003 10.355 2.81503L9.185 1.64503C8.99 1.45003 8.675 1.45003 8.48 1.64503L7.565 2.56003L9.44 4.43503L10.355 3.52003Z' fill='#199B8D' />
              </svg>
              {t('general:update')}
            </p>}
        </div>
      </div>
    </div>
  )
}

export default CartItem
